'use client';

import { usePathname } from '@module/mdrt-org/shared/i18n/i18n-navigation';
import { ChipTheme } from '@shared/ui-components/chip/chipTheme';

import { type LocalPaths } from '../../../../utils/data/get-local-paths';
import { useBreakpoint } from '../../../../utils/hooks/use-breakpoint';
import { Chip } from '../../../chip/chip';
import { isHeaderSecondaryTheme } from '../../utils/hooks/is-header-secondary-theme';

type StatusChipClientProps = {
  label?: string;
  paths: LocalPaths;
  url: string;
};

export const StatusChipClient = ({ label, paths, url }: StatusChipClientProps) => {
  const pathname = usePathname();

  const isSecondaryTheme = isHeaderSecondaryTheme({ pathname, paths });
  const { breakpoint, isLargeDesktop } = useBreakpoint();

  if (!label) {
    return null;
  }

  return (
    <Chip
      label={label}
      theme={
        isSecondaryTheme && (isLargeDesktop || breakpoint === undefined)
          ? undefined
          : ChipTheme.Light
      }
      to={url}
    />
  );
};
